<template>
<div style="padding:40px; 50px;"> 
    
  <div class="conteudo" v-for="(n,i) in $store.state.dados" :key="i">
    <div class="acompanhamento">
        <div class="quadradro">

        </div>
        <div class="linha">

        </div>
    </div>
    <div>
         
        <p v-titulo> <span v-if="n.data != undefined"> {{n.data}}</span>  <b v-if="n.tipo">({{n.tipo}}) -</b> {{n.titulo}}</p>
        <p >{{n.titulo}}</p>
        <div v-html="n.conteudo"></div>
        <div v-for="(nj,j) in n.listaItens" :key="j"  >       
            <div v-if="nj.link" style="margin-top:15px;display: flex;">
            <img src="/sandboxfront/declaracoes/img/Le.svg" alt="" v-if="nj.categoria == 'Legislação'" width="38px">
             <img src="/sandboxfront/declaracoes/img/quadrado.svg" alt="" v-else width="33px">
            <div style="margin-left:10px;"  >
              
                <p v-titulo style="margin-bottom:0px;" v-if="j ==0 ? true : n.listaItens[j-1].categoria == nj.categoria ? false : true">{{nj.categoria}}</p>
                <a :href="nj.link" target="_blank">{{nj.titulo}}</a>
            </div>
            </div>
        </div>
    </div>
</div>
 </div>
  
</template>

<script>
export default {
   
}
</script>

<style> 
p{
    margin:0px
}
.conteudo .acompanhamento .quadradro{
    width: 13px;
    height: 15px;
    background: #4A154B;
}
.conteudo .acompanhamento .linha{
    height:100%;
    width: 1px ;
    background: #afafaf;
    margin-top:10px

}
.conteudo .acompanhamento {
    display: flex;
    align-items: center;
    margin-right: 20px;
    justify-content: center;
    flex-direction: column;
}
.conteudo{
    display: flex;
    margin-top:40px;
    font-size:16px;
}

</style>